import { $_DKD } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api.js";

export default {
    state: {
        welcomeList: [],
        newWelcList: [],
    },
    getters: {
        getWelcomeList(state) {
            return state.welcomeList;
        },
        getNewWelcList(state) {
            return state.newWelcList;
        },
    },
    mutations: {
        WELCOME_LIST(state, welcomeList) {
            state.welcomeList = welcomeList;
        },
        NEW_WELC_LIST(state, newWelcList) {
            state.newWelcList = newWelcList;
        },
    },
    actions : {
        FETCH_WELCOME_LIST({commit}) {
            // return commonApi.fetchRepoDataListWithCodeName($_DKD.WELCOME, '',true)
            return commonApi.fetchRepoDataListWithCodeName($_DKD.WELCOME_CITIZEN, '',true)
                .then(res => {
                    let list = res.data.data;
                    
                    list = list.filter(welcome => {
                        return welcome.val2 == 'Y';
                    }).sort((prom1, prom2) => {
                        let prom1No = prom1.basdtVal;
                        let prom2No = prom2.basdtVal;
                        return Number(prom2No) - Number(prom1No);
                    });
                    commit('WELCOME_LIST', list);
                })
        },
        FETCH_NEW_WELC_LIST({commit}) {
            // return commonApi.fetchRepoDataListWithCodeName($_DKD.WELCOME, '',true)
            return commonApi.fetchRepoDataListWithCodeName($_DKD.NEW_WELC, '',true)
                .then(res => {
                    let list = res.data.data;
                    list = list.filter((d) => {
                        return d.val3 != 'N';
                    });
                    list = list.sort((pre, cur) => {
                        if(isNaN(pre.val1)) pre.val1 = 0;
                        if(isNaN(cur.val1)) cur.val1 = 0;
                        return Number(cur.val1) - Number(pre.val1);
                    });
                    commit('NEW_WELC_LIST', list);
                })
        },
    }
};
